export default "__VITE_ASSET__X97ZPc$F__"